import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0144',
    ecrans: ['00-2'],
    params: ['id', 'tsfcleint']
});

